"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lightbox_1 = __importDefault(require("photoswipe/lightbox"));
window.onload = () => {
    console.log("Loading Lightbox :)");
    init_nav();
    show_gallery('gallery-default');
};
var lightbox;
function init_nav() {
    console.log("Init Nav");
    let sidebar = document.getElementById("sidebar");
    if (!sidebar)
        return;
    let nav_entries = sidebar.getElementsByTagName("li");
    for (let entry of nav_entries !== null && nav_entries !== void 0 ? nav_entries : []) {
        entry.addEventListener("click", function (e) {
            var _a;
            let target = e.target;
            if (target.classList.contains("active")) {
                target.classList.remove("active");
                show_gallery("gallery-default");
            }
            else {
                let gallery_id = (_a = target.getAttribute("data-target")) !== null && _a !== void 0 ? _a : "default";
                show_gallery(gallery_id);
                for (let entry of nav_entries !== null && nav_entries !== void 0 ? nav_entries : [])
                    entry.classList.remove("active");
                target.classList.add("active");
            }
        });
    }
}
function show_gallery(id) {
    var _a;
    console.log("Showing Gallery: " + id);
    if (lightbox) {
        lightbox.destroy();
    }
    let galleries = Array.from(document.getElementsByClassName("pswp-gallery"));
    galleries.forEach(gallery => gallery.classList.add("hide"));
    (_a = document.getElementById(id)) === null || _a === void 0 ? void 0 : _a.classList.remove("hide");
    lightbox = new lightbox_1.default({
        gallery: '#' + id,
        children: 'a',
        pswpModule: () => import('photoswipe')
    });
    lightbox.init();
    /*
    let mean_red = 0;
    let mean_green = 0;
    let mean_blue = 0;
    let counter = 0;

    let gallery = document.getElementById(id)?.getElementsByTagName("a");
    if (!gallery) return;
    for (let img of Array.from(gallery)) {
        let mean_color_hex = img.getAttribute("data-mean-color");
        if (!mean_color_hex) continue;
        mean_red += parseInt(mean_color_hex.substring(1, 3), 16);
        mean_green += parseInt(mean_color_hex.substring(3, 5), 16);
        mean_blue += parseInt(mean_color_hex.substring(5, 7), 16);
        counter++;
    }
    if (counter > 0) {
        mean_red = mean_red / counter;
        mean_blue = mean_blue / counter;
        mean_green = mean_green / counter;
        console.log("Overall Mean Color: " + mean_red + ", " + mean_green + ", " + mean_blue + "");
    }*/
}
